import { Link } from "react-router-dom";
import type { Work } from "@/types";

export default function HotPlots({ items }: { items: Work[] }) {
  return (
    <div className="flex flex-col gap-3">
      {items.map((work, i) => (
        <Link
          key={work.id}
          to={`/detail/${work.id}`}
          className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:border-primary-300 sm:flex-row animate-fade-up"
          style={{ animationDelay: `${i * 70}ms` }}
        >
          <div className="relative h-32 w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-24 sm:w-40">
            <img
              src={work.backdrop}
              alt={`${work.title}剧照`}
              title={`${work.title}剧情介绍`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute left-1.5 top-1.5 flex items-center gap-1 rounded bg-primary-900/80 px-1.5 py-0.5 text-[10px] text-background-50 backdrop-blur">
              <i className="ri-play-fill text-[9px]"></i>看点
            </span>
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <h3 className="font-heading text-base font-bold text-foreground-950 line-clamp-1">
                {work.title}
              </h3>
              <span className="ml-auto flex shrink-0 items-center gap-1 text-xs font-semibold text-accent-600">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-star-fill text-[10px]"></i>
                </span>
                {work.rating.toFixed(1)}
              </span>
            </div>
            <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 line-clamp-2">
              {work.synopsis}
            </p>
            <div className="mt-2.5 flex flex-wrap items-center gap-2">
              {work.genres.slice(0, 2).map((g) => (
                <span
                  key={g}
                  className="rounded-full bg-accent-50 px-2 py-0.5 text-[11px] text-accent-700"
                >
                  {g}
                </span>
              ))}
              <span className="text-[11px] text-foreground-500">
                导演 {work.director}
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}